import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getWriters, getWriter, addWriter, editWriter } from './scoutSettingsActions';
import { SCOUT_SETTINGS_FILTER } from '../../../constants';

const initialState = {
  writersList: [],
  isWritersLoading: false,
  writersTotal: 0,
  editableWriter: {},
  isWriterFormLoading: false,

  tableSettings: {
    page: 0,
    size: 10,
    sort: '-updatedOn',
  },
  tableFilters: {
    language: '',
    filterBy: SCOUT_SETTINGS_FILTER.WRITER,
  },
};

const scoutSettings = createSlice({
  name: 'scoutSettings',
  initialState,
  reducers: {
    changeTablePage: (state, action) => {
      state.tableSettings.page = action.payload;
    },
    changeTableSize: (state, action) => {
      state.tableSettings.size = action.payload;
      state.tableSettings.page = 0;
    },
    changeTableSort: (state, action) => {
      state.tableSettings.sort = action.payload;
      state.tableSettings.page = 0;
    },
    changeTableLanguage: (state, action) => {
      state.tableSettings.page = 0;
      state.tableFilters.language = action.payload;
    },
    changeTableFilterBy: (state, action) => {
      state.tableSettings.page = 0;
      state.tableFilters.filterBy = action.payload;
    },
    resetEditableWriter: (state) => {
      state.editableWriter = {};
      state.isWriterFormLoading = false;
    },
    resetScoutSettingsData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWriters.fulfilled, (state, action) => {
        state.isWritersLoading = false;
        state.writersList = action.payload.content;
        state.writersTotal = action.payload.total;
      })
      .addCase(getWriter.fulfilled, (state, action) => {
        state.isWriterFormLoading = false;
        state.editableWriter = action.payload;
      })
      .addMatcher(isAnyOf(getWriters.pending), (state) => {
        state.isWritersLoading = true;
      })
      .addMatcher(isAnyOf(getWriters.rejected), (state) => {
        state.isWritersLoading = false;
      })
      .addMatcher(isAnyOf(getWriter.pending, addWriter.pending, editWriter.pending), (state) => {
        state.isWriterFormLoading = true;
      })
      .addMatcher(isAnyOf(getWriter.rejected, addWriter.rejected, editWriter.rejected), (state) => {
        state.isWriterFormLoading = false;
      })
      .addMatcher(isAnyOf(addWriter.fulfilled, editWriter.fulfilled), (state) => {
        state.isWriterFormLoading = false;
      });
  },
});

export const {
  changeTablePage,
  changeTableSize,
  changeTableSort,
  changeTableLanguage,
  changeTableFilterBy,
  resetScoutSettingsData,
  resetEditableWriter,
} = scoutSettings.actions;

export default scoutSettings.reducer;
